import React from 'react';
import { Link, graphql } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import styled from '@emotion/styled';

import { rhythm, scale } from '../utils/typography';
import Bio from '../components/Bio';
import Layout from '../components/Layout';
import SEO from '../components/seo';
import Navbar from '../components/Navbar';
import { RedText } from '../components/typo';
import HeroIntro from '../components/HeroIntro';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const Title = styled.h1`
  width: 100%;
  text-align: center;
  margin-bottom: ${rhythm(0.3)};
`;

const Byline = styled.p`
  text-align: center;
  color: #cc0000;
`;

const Hr = styled.div`
  border-bottom: 3px solid #cc0000;
  margin: ${rhythm(1)} 0;
`;

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.mdx;
    const siteTitle = this.props.data.site.siteMetadata.title;
    const { previous, next } = this.props.pageContext;
    console.log(this.props.pageContext);

    return (
      <>
        <Navbar />
        <Layout location={this.props.location} title={siteTitle}>
          <SEO title={post.frontmatter.title} description={post.excerpt} />
          <Title>
            {post.frontmatter.title}
            <RedText>.</RedText>
          </Title>
          <Byline>{post.frontmatter.date}</Byline>
          <MDXRenderer>{post.body}</MDXRenderer>
          <Hr />
          <Bio />

          <ul
            style={{
              display: `flex`,
              flexWrap: `wrap`,
              justifyContent: `space-between`,
              listStyle: `none`,
              padding: 0,
            }}
          >
            <li>
              {previous && (
                <Link to={previous.fields.slug} rel="prev">
                  ← {previous.frontmatter.title}
                </Link>
              )}
            </li>
            <li>
              {next && (
                <Link to={next.fields.slug} rel="next">
                  {next.frontmatter.title} →
                </Link>
              )}
            </li>
          </ul>
        </Layout>
        <HeroIntro />
        <ContactSection />
        <Footer />
      </>
    );
  }
}

export default BlogPostTemplate;

export const pageQuery = graphql`
  query($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    mdx(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
      }
      body
    }
  }
`;
